import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';

import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

export default function NavbarBreadcrumbs() {
  const location = useLocation();
  const { t } = useTranslation("breadcrumbs");
  const breadcrumbs = generateBreadcrumbs();

  const pathPrefix = location.pathname.includes("admin") ? "/admin" : "";

  function isDynamicSegment(segment) {
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(segment);
  }

  function generateBreadcrumbs() {
    const pathWithoutParams = location.pathname;
    const pathSegments = pathWithoutParams.split("/").filter(Boolean);
    if (pathSegments.length > 0 && pathSegments[0] === "admin") {
      pathSegments.shift();
    }
    const filteredSegments = pathSegments.filter(segment => !isDynamicSegment(segment));
    const filteredSegmentsCleaned = filteredSegments.map(
      segment => {
        const extractedSegment = segment.charAt(0) + segment.slice(1)
        return {
          translated: t(extractedSegment),
          urlPart: extractedSegment
        }
      }
    );

    return filteredSegmentsCleaned;
  }

  function getUrlParts(parts) {
    return parts.map(part => part.urlPart)
  }
  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextIcon fontSize="small"
        sx={{
          display: 'flex',
          justifyContent: 'center', // Center breadcrumbs horizontally
          alignItems: 'center', // Align vertically
          width: '100%', // Ensure full width for centering
        }}
      />

      }
    >

        <Link to={"/"} style={{ textDecoration: 'none', color: 'inherit', display: 'flex' , alignItems: 'center'}}>
          <HomeIcon fontSize="small" color="text.secondary" />
        </Link>

      {
        breadcrumbs.map((crumb, index) => (
          <Box key={index} sx={{
            height: "100%", display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <Link to={`${pathPrefix}/${getUrlParts(breadcrumbs.slice(0, index + 1)).join("/").toLowerCase()}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <Typography variant="text" color="text.secondary">
                {crumb.translated}
              </Typography>
            </Link>
          </Box>
        ))
      }
    </StyledBreadcrumbs >
  );
}
